import { Directive, OnChanges, OnDestroy, Input, Output, ElementRef, EventEmitter, SimpleChanges, OnInit } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { takeUntil } from 'rxjs/operator/takeUntil';
import { fromEvent } from 'rxjs/observable/fromEvent';
@Directive({
    selector: '[buiDraggble]'
})
export class DraggbleDirective implements OnDestroy, OnChanges, OnInit {

    @Input() dragEventTarget: any;
    @Input() dragModel: any;
    @Input() dragX = true;
    @Input() dragY = true;

    @Output() dragStart = new EventEmitter();
    @Output() dragging = new EventEmitter();
    @Output() dragEnd = new EventEmitter();

    _element: HTMLElement;
    isDragging = false;
    subscription: Subscription;

    constructor(elementRef: ElementRef) {
        this._element = elementRef.nativeElement;
    }
    ngOnInit() {
        let handle = document.createElement('span')
        handle.setAttribute('class', 'drag-handle')
        this._element.appendChild(handle)
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['dragEventTarget'] && changes['dragEventTarget'].currentValue && this.dragModel.dragging) {
            this.onMousedown(changes['dragEventTarget'].currentValue);
        }
    }
    ngOnDestroy() { }

    onMousedown(event: MouseEvent): void {
        // 只拖拽表头内部的文字
        const isDragElm = (<HTMLElement>event.target).classList.contains('draggable');
        if (isDragElm && (this.dragX || this.dragY)) {
            event.preventDefault();
            this.isDragging = true;
            const mouseDownPos = { x: event.clientX, y: event.clientY };
            const mouseup = Observable.create(fromEvent(document, 'mouseup'))
            this.subscription = mouseup
                .subscribe((ev: MouseEvent) => this.onMouseup(ev));
            const mouseMoveSub = Observable.create(fromEvent(document, 'mousemove')).takeUntil(mouseup)
                .subscribe((ev: MouseEvent) => this.move(ev, mouseDownPos));
            this.subscription.add(mouseMoveSub);
            this.dragStart.emit({
                event,
                element: this._element,
                model: this.dragModel
            });
        }
    }
    onMouseup(event: MouseEvent): void {
        if (!this.isDragging) { return; }
        this.isDragging = false;
        this._element.classList.remove('dragging');
        if (this.subscription) {
            this._destroySubscription();
            this.dragEnd.emit({
                event,
                element: this._element,
                model: this.dragModel
            });
        }
    }
    move(event: MouseEvent, mouseDownPos: { x: number, y: number }): void {
        if (!this.isDragging) { return; }
        const x = event.clientX - mouseDownPos.x;
        const y = event.clientY - mouseDownPos.y;
        if (this.dragX) { this._element.style.left = `${x}px`; }
        if (this.dragY) { this._element.style.top = `${y}px`; }
        this._element.classList.add('dragging');
        this.dragging.emit({
            event,
            element: this._element,
            model: this.dragModel
        });
    }
    private _destroySubscription(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = undefined;
        }
    }
}
